/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { STAR_WARS } from "../../assets/images";
export const TEST_DATA = [
    {
        idx: "1",
        title: "Johnnie Walker Blue Label Blended Scotch",
        subtitle:
            "Johnnie Walker Blue Label Blended Scotch",
        serialNo: "Rare #/1",
        img: "https://i.ibb.co/Hqj3kJn/1-Blue-Label-Legendary.png/:/rs=w:1000",
        tag: "PLATINUM",
        category: "platinum",
        price: [
            {
                type: "fiat",
                currency: "USD",
                locale: "en-US",
                amount: 1200.0,
            },
            {
                type: "crypto",
                currency: "ETH",
                amount: 0.323,
            },
        ],
    },
    {
        idx: "2",
        title: "Antiquity Blue Ultra Premium Whisky",
        subtitle:
            "Antiquity Blue Ulta Premium Whisky",
        serialNo: "Rare #/2",
        img: "https://i.ibb.co/F0J90gQ/2-ANTIQUITY-BLUE-ULTRA-PREMIUM-WHISKY.jpg/:/rs=w:1000",
        tag: "PLATINUM",
        category: "platinum",
        price: [
            {
                type: "fiat",
                currency: "USD",
                locale: "en-US",
                amount: 1200.0,
            },
            {
                type: "crypto",
                currency: "ETH",
                amount: 0.3,
            },
        ],
    },
    {
        idx: "3",
        title: "Ciroc Vodka",
        subtitle:
            "Ciroc Vodka",
        serialNo: "Rare #/3",
        img: "https://i.ibb.co/yyckSnZ/6-ciroc.jpg/:/rs=w:1000",
        tag: "PLATINUM",
        category: "platinum",
        price: [
            {
                type: "fiat",
                currency: "USD",
                locale: "en-US",
                amount: 1700.0,
            },
            {
                type: "crypto",
                currency: "ETH",
                amount: 0.489,
            },
        ],
    },
    {
        idx: "4",
        title: "Black & White Blended Scotch Whisky",
        subtitle:
            "Black & White Blended Scotch Whisky",
        serialNo: "Rare #/4",
        img: "https://i.ibb.co/6vDqfgn/10-Black-And-White.jpg/:/rs=w:500",
        tag: "DIAMOND",
        category: "diamond",
        price: [
            {
                type: "fiat",
                currency: "USD",
                locale: "en-US",
                amount: 2000.0,
            },
            {
                type: "crypto",
                currency: "ETH",
                amount: 0.55,
            },
        ],
    },
    {
        idx: "5",
        title: "Signature Rare Aged Whisky",
        subtitle:
            "Signature Rare Aged Whisky",
        serialNo: "Rare #/5",
        img: "https://i.ibb.co/xY1MJCn/7-SIGNATURE-RARE-AGED-WHISKY.jpg/:/rs=w:1000",
        tag: "PLATINUM",
        category: "platinum",
        price: [
            {
                type: "fiat",
                currency: "USD",
                locale: "en-US",
                amount: 1800.0,
            },
            {
                type: "crypto",
                currency: "ETH",
                amount: 0.5,
            },
        ],
    },
    {
        idx: "6",
        title: "Tanqueray London Dry Gin",
        subtitle:
            "Tanqueray London Dry Gin",
        serialNo: "Rare #/6",
        img: "https://i.ibb.co/9qMK52Q/5-Tanqueray-Gin.png/:/rs=w:1000",
        tag: "PLATINUM",
        category: "platinum",
        price: [
            {
                type: "fiat",
                currency: "USD",
                locale: "en-US",
                amount: 1400.0,
            },
            {
                type: "crypto",
                currency: "ETH",
                amount: 0.39,
            },
        ],
    },
    {
        idx: "7",
        title: "McDowells No.1 Reserve Whisky",
        subtitle:
            "McDowells No.1 Reserve Whisky",
        serialNo: "Rare #/7",
        img: "https://i.ibb.co/mT3Tm6T/8-MCDOWELLS-NO-1-RESERVE-WHISKY.jpg/:/rs=w:1000",
        tag: "PLATINUM",
        category: "platinum",
        price: [
            {
                type: "fiat",
                currency: "USD",
                locale: "en-US",
                amount: 2800.0,
            },
            {
                type: "crypto",
                currency: "ETH",
                amount: 0.69,
            },
        ],
    },
    {
        idx: "8",
        title: "Black Dog Scotch Whisky",
        subtitle:
            "Black Dog Scotch Whisky",
        serialNo: "Rare #/8",
        img: "https://i.ibb.co/7J7VDqt/9-Black-Dog.jpg/:/rs=w:1000",
        tag: "PLATINUM",
        category: "platinum",
        price: [
            {
                type: "fiat",
                currency: "USD",
                locale: "en-US",
                amount: 2500.0,
            },
            {
                type: "crypto",
                currency: "ETH",
                amount: 0.69,
            },
        ],
    },
    {
        idx: "9",
        title: "Baileys Irish Whisky",
        subtitle:
            "Baileys Irish Whisky",
        serialNo: "Rare #/9",
        img: "https://i.ibb.co/fCxXbVS/12-baileys-liqueur.jpg/:/rs=w:1000",
        tag: "PLATINUM",
        category: "platinum",
        price: [
            {
                type: "fiat",
                currency: "USD",
                locale: "en-US",
                amount: 1200.0,
            },
            {
                type: "crypto",
                currency: "ETH",
                amount: 0.3,
            },
        ],
    },
    {
        idx: "10",
        title: "Directors Special Whisky",
        subtitle: "Directors Special Whisky",
        serialNo: "Rare #/10",
        img: "https://i.ibb.co/CK9wtDD/11-Directors-Special-Whisky.png:/rs=w:500",
        tag: "DIAMOND",
        category: "diamond",
        price: [
            {
                type: "fiat",
                currency: "USD",
                locale: "en-US",
                amount: 1500.0,
            },
            {
                type: "crypto",
                currency: "ETH",
                amount: 0.5123,
            },
        ],
    }, 
    {
        idx: "11",
        title: "Smirnoff Vodka",
        subtitle:
            "Smirnoff Vodka",
        serialNo: "Rare #/11",
        img: "https://i.ibb.co/HK8mWsk/3-Smirnoff.jpg/:/rs=w:1000",
        tag: "PLATINUM",
        category: "platinum",
        price: [
            {
                type: "fiat",
                currency: "USD",
                locale: "en-US",
                amount: 1200.0,
            },
            {
                type: "crypto",
                currency: "ETH",
                amount: 0.3,
            },
        ],
    },
    {
        idx: "12",
        title: "Vat 69 is a blended Scotch whisky",
        subtitle:
            "Vat 69 is a blended Scotch whisky",
        serialNo: "Rare #/12",
        img: "https://i.ibb.co/N9C22sP/4-vat-69-black.png/:/rs=w:1000",
        tag: "PLATINUM",
        category: "platinum",
        price: [
            {
                type: "fiat",
                currency: "USD",
                locale: "en-US",
                amount: 2500.0,
            },
            {
                type: "crypto",
                currency: "ETH",
                amount: 0.69,
            },
        ],
    },
];

export const FilterData = [
    {
        type: "button",
        title: "Type",
        key: "ex4",
        categories: [
            { label: "Crypto", value: "Crypto" },
            { label: "NFT", value: "NFT" },
        ],
    },
    {
        type: "button",
        title: "Country",
        key: "id-4",
        categories: [
            { label: "India", value: "Ind" },
            { label: "U.S.A.", value: "usa" },
            { label: "Canada", value: "canada" },
            { label: "Barbados", value: "barbados" },
            { label: "Dominica", value: "dominica" },
            { label: "Jamaica", value: "jamaica" },
        ],
    },
    {
        type: "checkbox",
        title: "Categories",
        key: "id-5",
        categories: [
            { label: "Music", value: "Music" },
            { label: "Adventure", value: "Adventure" },
            { label: "The Lord of the Rings", value: "The Lord of the Rings" },
            { label: "Star War", value: "Star War" },
            { label: "Life Is Beautiful ", value: "Life Is Beautiful " },
            { label: "Coachella", value: "Coachella" },
            { label: "Lollapalooza", value: "Lollapalooza" },
            {
                label: "Pitchfork Music Festival",
                value: "Pitchfork Music Festival",
            },
            { label: "Sci-Fi", value: "Sci-Fi" },
            { label: "The Godfather", value: "The Godfather" },
            {
                label: "Electric Daisy Carnival Las Vegas",
                value: "Electric Daisy Carnival Las Vegas",
                disabled: true,
            },
            { label: "Comedy", value: "Comedy" },
            { label: "Mystery", value: "Mystery" },
            { label: "Plants", value: "Plants" },
            { label: "Ultra Music Festival", value: "Ultra Music Festival" },
        ],
    },
    {
        type: "checkbox",
        title: "Time period",
        key: "id-6",
        categories: [
            { label: "2001-2004", value: "2001-2004" },
            { label: "2005-2008", value: "2005-2008" },
            { label: "2009-2012", value: "2009-2012" },
            { label: "2013-2016", value: "2013-2016" },
            { label: "2017-2020", value: "2017-2020", disabled: true },
            { label: "2021", value: "2021" },
        ],
    },
    {
        type: "range",
        title: "Price",
        key: "id-9",
        min: 0,
        max: 200,
        default: "ETH",
        subCategoriesTitle: "Currency",
        categories: [
            { label: "USD", value: "USD" },
            { label: "Ethereum", value: "ETH" },
            { label: "Indian Rupee", value: "INR" },
        ],
    },
];
